import React from 'react';

import KeyChip from '@dashboard/components/KeyChip';
import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import { Link, Stack, Typography } from '@mui/material';

import DisableStepCheckbox from '../components/DisableStepCheckbox';
import { useWorkflowStepType } from '../useWorkflowStepField';

import SendEmailTemplateMessage from './SendEmailTemplateMessageForm';
import SendMarkdownEmailMessage from './SendMarkdownEmailMessageForm';
import TemplateSelectField from './TemplateSelectField';

type Props = {
  name: string;
};
export default function SendEmailMessageActionSection({ name }: Props) {
  const type = useWorkflowStepType(name);

  const renderStepFields = () => {
    if (type === null) {
      return null;
    }
    switch (type) {
      case 'sendMarkdownEmailMessage':
        return <SendMarkdownEmailMessage name={name} />;
      case 'sendEmailTemplateMessage':
        return <SendEmailTemplateMessage name={name} />;
      case 'sleep':
        return null;
    }
  };

  return (
    <BaseSettingCard title="Send email" actions={<DisableStepCheckbox name={name} />}>
      <Stack spacing={1} mt={3}>
        <Typography paragraph>
          Reference variables from the data above using{' '}
          <Link
            color="inherit"
            underline="hover"
            fontWeight="fontWeightMedium"
            target="_blank"
            href="https://liquidjs.com/tutorials/intro-to-liquid.html"
          >
            Liquid templating
          </Link>
          . Example: <KeyChip label={'{{variable}}'} />.
        </Typography>
        <TemplateSelectField name={name} />
        {renderStepFields()}
      </Stack>
    </BaseSettingCard>
  );
}
